<template>
  <div>
    <el-table
      v-if="bookings.length"
      :data="bookings"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      cell-class-name="fifl-main-table-cell"
      v-loading="isBookingDataLoad"
      @filter-change="onChangeBookingTableFilter"
    >
      <el-table-column
        label="번호"
        type="index"
        :index="presentBookingHistoryIndex"
        :min-width="columnWidth.index + 'px'"
      />
      <el-table-column
        label="수업"
        show-overflow-tooltip
        :min-width="columnWidth.course_name + 'px'"
        prop="course_name"
      >
        <template slot-scope="scope">
          <router-link :to="makeCourseLink(scope.row)">
            {{ scope.row.course_name }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        label="일시"
        prop="dt"
        :min-width="columnWidth.dt + 'px'"
      >
        <template slot-scope="scope">
          {{ format(scope.row.dt, 'YY.MM.DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        label="강사"
        show-overflow-tooltip
        prop="instructors_name"
      >
        <template slot-scope="scope">
          {{ scope.row.instructors_name.join(', ') }}
        </template>
      </el-table-column>
      <el-table-column
        label="이용 회원권"
        sortable
        show-overflow-tooltip
        prop="instructors_name"
        column-key="parent_membership"
        :min-width="columnWidth.membership + 'px'" 
        :filters="membershipFilter"
      >
        <template slot-scope="scope">
          {{ scope.row.parent_membership.name }}
        </template>
      </el-table-column>
      <el-table-column
        :label="'차감 ' + membershipSystem.middle"
        prop="consumed"
        :min-width="columnWidth.consumed + 'px'"
      >
        <template slot-scope="scope">
          {{ numberWithCommas(scope.row.consumed * -1) }}
        </template>
      </el-table-column>
      <el-table-column
        label="상태"
        prop="status"
        column-key="booking_status"
        sortable
        :min-width="columnWidth.status + 'px'"
        :filters="bookingFilter"
      >
        <template slot-scope="scope">
          <div :class="[scope.row.status]">
            {{ scope.row.statusLabel }}
          </div>
        </template>
      </el-table-column> 
      <el-table-column
        label=""
        prop="attendance"
        :min-width="columnWidth.empty + 'px'"
        fixed="right"
        class-name="more-action__column"
      >
        <template slot-scope="scope">
          <attendance-control-dropdown
            :data="scope.row"
            :disabled="!scope.row.attendance || scope.row.statusLabel === PRESENT_BOOKING_STATUS.WAITING"
            @update="syncBookingData"
          />
        </template>
      </el-table-column>
    </el-table>
    <empty-table 
      v-else
      :props-loading-status="isBookingDataLoad"
      :props-has-parent="emptyTableProps.hasParent"
      :props-is-icon="emptyTableProps.isIcon"
      :props-header-height="emptyTableProps.headerHeight"
      :props-data="emptyTableProps.data"
      :props-table-body-height="emptyTableProps.bodyHeight"
      :props-message="emptyTableProps.message" 
    />
    <div
      v-show="bookings.length !== 0"
      style="text-align: center; margin-top: 25px;"
    >
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="curPage"
        :total="totalDataCount"
        @current-change="onChangeCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import AttendanceControlDropdown from '@/components/AttendanceControlDropdown';
import { computedGetters } from '@/utils/vuex-helper';
import {
  getBookingStatus,
  PRESENT_BOOKING_STATUS
} from '@/utils/booking-status';
import EmptyTable from '@/components/EmptyTable';
import dateFns from 'date-fns';
import { fiflboxApi } from '@/utils/api';
import { numberWithCommas } from '@/utils/etc';

export default {
  name: 'MemberDetailBookingTable',
  components: {
    EmptyTable,
    AttendanceControlDropdown
  },
  props: ['enrollmentId'],
  data() {
    return {
      PRESENT_BOOKING_STATUS,
      membershipFilter: [],
      bookingFilter: [
        {
          text: '예약',
          value: 'BOOKED'
        },
        {
          text: '대기',
          value: 'WAITING'
        },
        {
          text: '출석',
          value: 'ATTENDANCE'
        },
        {
          text: '지각',
          value: 'LATE'
        },
        {
          text: '결석',
          value: 'NOSHOW'
        }
      ],
      bookings: [],
      bookingQueryOptions: {
        attendance__status: [],
        parent_membership: [],
        standard_timeline: ''
      },
      totalDataCount: 0,
      curPage: 1,
      pageLimit: 10,
      hasFilterStatus: false,
      statusQuery: {
        isFilter: false,
        isBooked: false,
        isWaiting: false,
        isPass: false,
        queryset: []
      },
      membershipQuery: {
        isFilter: false,
        queryset: []
      },
      hasBookedCategoryInFilter: false,
      isBookingDataLoad: true,
      columnWidth: {
        index: 70,
        course_name: 200,
        dt: 100,
        membership: 250,
        consumed: 100,
        status: 80,
        empty: 50
      },
      emptyTableProps: {
        message: '수강 내역이 없습니다.',
        bodyHeight: 335,
        headerHeight: 51,
        hasParent: false,
        isIcon: true,
        data: [
          { label: '번호', width: 70 + 'px' },
          { label: '수업', width: 'calc(100% - 580px)' },
          { label: '일시', width: 200 + 'px' },
          { label: '강사', width: 80 + 'px' },
          { label: '차감', width: 80 + 'px' },
          { label: '상태', width: 100 + 'px' },
          { label: '', width: 50 + 'px' }
        ]
      }
    };
  },
  computed: {
    ...computedGetters(['membershipSystem'])
  },
  async created() {
    await this.syncBookingData();
    await this.makeMembershipFilter();
  },
  methods: {
    format: dateFns.format,
    numberWithCommas,
    makeCourseLink(data) {
      return {
        path: '/schedule',
        query: {
          childCourseId: data.child_course,
          dt: data.dt,
          dialogTab: 'booking'
        }
      };
    },
    presentBookingHistoryIndex(index) {
      return this.pageLimit * (this.curPage - 1) + index + 1;
    },
    makeBookingListQuery() {
      const params = {
        enrollment: this.enrollmentId,
        status: [],
        limit: this.pageLimit,
        offset: (this.curPage - 1) * this.pageLimit
      };

      // 상태 필터
      if (this.statusQuery.isFilter) {
        if (this.statusQuery.isWaiting) {
          params.status.push('WAITING');
        }
        if (this.statusQuery.isBooked || this.statusQuery.isPass) {
          params.status.push('BOOKED');
        }
        if (this.statusQuery.isPass) {
          params.status.push('PASS');
          params.dt_before = this.bookingQueryOptions.standard_timeline;
        }
        if (this.statusQuery.isWaiting || this.statusQuery.isBooked) {
          params.dt_after = this.bookingQueryOptions.standard_timeline;
        }

        params.attendance__status = this.bookingQueryOptions.attendance__status;
        //Attendance Table에는 BOOKED 라는 상태가 존재하지 않기 때문에 삭제해준다.
        if (this.statusQuery.isBooked || this.statusQuery.isWaiting) {
          //copy.
          const tempStatus = this.bookingQueryOptions.attendance__status.slice();
          if (this.statusQuery.isBooked) {
            const bookedStatusIndex = this.bookingQueryOptions.attendance__status.indexOf(
              'BOOKED'
            );
            //splice BOOKED in params.
            params.attendance__status.splice(bookedStatusIndex, 1);
          }

          if (this.statusQuery.isWaiting) {
            const waitingStatusIndex = this.bookingQueryOptions.attendance__status.indexOf(
              'WAITING'
            );
            //splice WAITING in params.
            params.attendance__status.splice(waitingStatusIndex, 1);
          }

          //assign copied attendance status array.
          this.bookingQueryOptions.attendance__status = tempStatus;
        }
      } else {
        params.status = ['BOOKED', 'PASS', 'WAITING'];
      }

      // 회원권 필터
      if (this.membershipQuery.isFilter) {
        params.parent_membership = this.bookingQueryOptions.parent_membership;
      }
      const isMultipleCondition =
        params.hasOwnProperty('dt_after') && params.hasOwnProperty('dt_before');
      if (isMultipleCondition) {
        const multipleParams = {
          enrollment: params.enrollment,
          filter_status: params.status,
          filter_attendance__status: params.attendance__status,
          limit: this.pageLimit,
          offset: (this.curPage - 1) * this.pageLimit,
          is_multiple: true
        };
        return multipleParams;
      }
      return params;
    },
    async syncBookingData() {
      const params = this.makeBookingListQuery();
      try {
        this.isBookingDataLoad = false;
        let { data } = await fiflboxApi.v1.getBookings(params);
        this.bookings = await this.responseDataSerializer(data.results);
        this.totalDataCount = data.count;
        //if there are NO Data when filtering, clear filter and reset list.
        if (
          (this.statusQuery.isFilter || this.membershipQuery.isFilter) &&
          data.count === 0
        ) {
          const title = '필터링된 데이터가 없습니다.';
          const message =
            '본 회원권을 가진 회원이 존재하지 않습니다. 확인 버튼을 누르면 필터링 옵션이 초기화된 상태로 돌아갑니다.';
          await this.$alert(message, title);
          setTimeout(async () => {
            this.clearFilter();
          }, 1000);
        } else {
          this.isBookingDataLoad = false;
        }
      } catch (err) {
        console.log(`${err}`);
      }
    },
    getBookingStatus,
    getBookingStatusInLabel(row) {
      const bookingStatus = getBookingStatus(row);
      return PRESENT_BOOKING_STATUS[bookingStatus];
    },

    onChangeCurrentPage() {
      this.syncBookingData();
    },
    async onChangeBookingTableFilter(filters) {
      const { booking_status, parent_membership } = filters;

      //1. Set status filtering queryset
      if (booking_status && booking_status.length) {
        this.statusQuery.isFilter = true;
        this.statusQuery.isBooked = booking_status.includes('BOOKED');
        this.statusQuery.queryset = booking_status;
        this.statusQuery.isWaiting = booking_status.includes('WAITING');
        this.statusQuery.isPass =
          booking_status.includes('LATE') ||
          booking_status.includes('ATTENDANCE') ||
          booking_status.includes('NOSHOW');
      } else {
        this.statusQuery.queryset = [];
      }

      //2. Set membership filtering queryset
      if (parent_membership && parent_membership.length) {
        this.membershipQuery.isFilter = true;
        this.membershipQuery.queryset = parent_membership;
      } else {
        this.membershipQuery.queryset = [];
      }

      //3. inject in param options
      this.bookingQueryOptions.attendance__status = this.statusQuery.queryset.slice();
      this.bookingQueryOptions.parent_membership = this.membershipQuery.queryset;
      this.bookingQueryOptions.standard_timeline = new Date().toISOString();
      this.setFirstPage();
      this.syncBookingData();
    },
    setFirstPage() {
      return (this.curPage = 1);
    },
    clearFilter() {
      this.statusQuery = {
        ...this.statusQuery,
        isFilter: false,
        isBooked: false,
        isWaiting: false,
        isPass: false,
        queryset: []
      };
      this.hasFilterStatus = false;
      this.hasBookedCategoryInFilter = false;
      this.bookingQueryOptions = {
        ...this.bookingQueryOptions,
        attendance__status: [],
        parent_membership: [],
        standard_timeline: ''
      };
      this.setFirstPage();
      this.syncBookingData();
    },
    makeMembershipFilter() {
      const idList = [];
      this.membershipFilter = [];
      for (let { parent_membership } of this.bookings) {
        const filterSerializer = { text: null, value: null };
        const { id, name } = parent_membership;
        if (!idList.includes(id)) {
          filterSerializer.text = name;
          filterSerializer.value = id;
          this.membershipFilter.push(filterSerializer);
          idList.push(id);
        }
      }
    },
    responseDataSerializer(datas) {
      const serializerResult = [];
      for (let data of datas) {
        try {
          const result = {
            ...data,
            status: getBookingStatus(data),
            statusLabel: this.getBookingStatusInLabel(data)
          };
          serializerResult.push(result);
        } catch (err) {}
      }
      return serializerResult;
    }
  }
};
</script>

<style lang="scss">
</style>
